import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import { ReactComponent as SavingBucketIcon } from '../../../assets/icons/svg/large-icons/ic-large-bucket-emergency.svg';
import Heading from '../../../generic-components/Heading';
import { FlowContext } from '../context';
import { STEPS, STYLES } from '../consts';
import { APY } from '../../../constants/general';

export const Intro = () => {
  const ctx = useContext(FlowContext);
  const { t } = useTranslation();

  function handleClick() {
    ctx?.changeActiveStep(STEPS.DASHBOARD);
  }

  return (
    <div className={STYLES.INTRO.wrapper}>
      <Heading title={t('SAVINGS_BUCKET.INTRO.pageTitle')} className={STYLES.INTRO.header} />
      <div className={STYLES.INTRO.contentContainer}>
        <SavingBucketIcon className={STYLES.INTRO.icon} />
        <Heading title={ctx.isSavingsBucket ? `${t('SAVINGS_BUCKET.INTRO.title_savings_part_a')} ${APY}${t('SAVINGS_BUCKET.INTRO.title_savings_part_b')}` : t('SAVINGS_BUCKET.INTRO.title')} className={STYLES.INTRO.mainTitle} />
        <Heading type='HTML' title={t('SAVINGS_BUCKET.INTRO.subHeader')} className={STYLES.INTRO.subTitle} />
        <LiliButton onClick={() => handleClick()} className='w-[200px]' title={t('SAVINGS_BUCKET.INTRO.cta')} id='startSavingCta' />
      </div>
      <footer className={STYLES.INTRO.footer} />
    </div>
  );
};
